import $ from 'jquery';
import { monitorAnimations } from './sections';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

export const timeout = {};
export const animateHome = (data) => {
    var $loader = $('#loader'),
        loadingDelay = 1000;

    // no loader detected
    if (!$loader.length || !$('body').hasClass('loading')) {
        monitorAnimations($('.animated'));
        return;
    }

    $('body')
        .imagesLoaded(
            {
                background: true,
            },
            function(a, b) {
                // body.loaded.loading
                $('body')
                    .addClass('loaded')
                    .delay(loadingDelay / 2)
                    .queue(function() {
                        // body.loaded
                        $('body').removeClass('loading');
                        $('body, html').scrollTop(0);
                        $('#loader').remove();

                        // toggle animations
                        monitorAnimations($('.animated'));

                        $(this).dequeue();
                    })
                    .delay(loadingDelay)
                    .queue(function() {
                        // body
                        $('body').removeClass('loaded');
                        $(this).dequeue();
                    });
            }
        )
        .progress(function(instance, image) {
            var $progress = $('#loader-progress'),
                // result = image.isLoaded ? 'LOADED' : 'BROKEN',
                total = instance.images.length,
                progress = Math.round((instance.progressedCount * 100) / total);

            // alert('jsut a pause');
            // console.log(result + ' ' + image.img.src );

            $progress.children().width(progress + '%');
        });
};
export const binds = () => {
    animateHome();
};
